<template>
	<div class="modal">
		<div class="overlay" @click="$emit('closeModal')"></div>
		<div class="modal_help">
			<span class="modal_close" @click="$emit('closeModal')"></span>
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'ModalHelp',
	mounted() {
		document.body.appendChild(this.$el);
	},
};
</script>

<style scoped></style>
